const CHECKLSIT = [
    {
        "index": 0,
        "checkList": " 읽기",
        "type": "checkbox"
    },
    {
        "index": 1,
        "checkList": "교역자영상 시청 후\n묵상질문에답해보기",
        "type": "checkbox"
    },
    {
        "index": 2,
        "checkList": "믿음 에세이를 읽고 실천 질문을\n순톡방에 나눠 보기",
        "type": "checkbox"
    },
    {
        "index": 4,
        "checkList": "실천일기 or 기도문 작성",
        "description":"하루간 실천한 믿음의 도전을 떠올리며\n일기 혹은 기도문으로 작성해 보세요\n(최대200자)",
        "type": "text"
    },
]
const CHECKLSIT_START = [
    {
        "index": 0,
        "checkList": "개인 비전보드 만들기\n(이미지만 찾아봐도 좋아요)",
        "type": "checkbox"
    },
    {
        "index": 1,
        "checkList": "순 카톡방에 개인 비전보드 공유하고\n(가능한 부분까지)선포하기",
        "type": "checkbox"
    },
    {
        "index": 2,
        "checkList": "비전보드를 바라보며\n믿음의 선포 기도로 하루 마무리하기",
        "type": "checkbox"
    },
]
const DAILY_READ = [
    "",
    "요한복음 20:24~29",
    "마태복음 14:22~33,\n마태복음 8:5~13",
    "마태복음 9:27~31",
    "마가복음 2:1~5",
    "마가복음 5:25~34",
    "마태복음 15:21~28",
    "누가복음 17-5~6,\n마태복음 17:20,\n마가복음 11:22~24"
]
export { CHECKLSIT , CHECKLSIT_START, DAILY_READ }